import onboardingBusiness from './onboardingBusiness';
import onboardingBusinessSoleTrader from './onboardingSoleTrader';
import onboardingBusinessZA from './onboardingBusinessZA';
import onboardingFreeOwner from './onboardingFreeOwner';
import onboardingFreeUser from './onboardingFreeUser';
import onboardingMemberBenefits from './onboardingMemberBenefits';
import onboardingProSponsor from './onboardingProSponsor';
import onboardingProUser from './onboardingProUser';
import onboardingProUserInvited from './onboardingProUserInvited';

const flows = {
  onboardingBusiness,
  onboardingBusinessSoleTrader,
  onboardingBusinessZA,
  onboardingFreeOwner,
  onboardingFreeUser,
  onboardingMemberBenefits,
  onboardingProSponsor,
  onboardingProUser,
  onboardingProUserInvited,
};

export function getOnboardingFlow(type, options) {
  const flow = flows[type];

  return !flow ? [] : flow(options);
}
